import { apiUrlV1 } from "../../config/config";

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

/** Thrown when the link is unknown, used or expired (the API answers 404). */
export class InvalidLinkError extends Error {}

/**
 * The one-time "set your password" link API. Public: no auth headers — the token in the link is
 * the only credential, so plain fetch is used instead of the authorized agent.
 */
export const fetchPasswordLink = async (token: string): Promise<{ email: string }> => {
  const res = await fetch(`${apiUrlV1}/auth/password-link/${encodeURIComponent(token)}`);
  if (res.status === 404) throw new InvalidLinkError();
  if (!res.ok) throw new Error(await errorMessage(res));
  return res.json();
};

export const submitPasswordLink = async (token: string, password: string): Promise<void> => {
  const res = await fetch(`${apiUrlV1}/auth/password-link`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
  });
  if (res.status === 404) throw new InvalidLinkError();
  if (!res.ok) throw new Error(await errorMessage(res));
};

/** The first problem with the two fields, or null when they can be submitted. */
export const passwordProblem = (password: string, confirm: string): string | null => {
  if (password.length < PASSWORD_MIN_LENGTH)
    return `At least ${PASSWORD_MIN_LENGTH} characters`;
  if (password.length > PASSWORD_MAX_LENGTH)
    return `At most ${PASSWORD_MAX_LENGTH} characters`;
  if (password !== confirm) return "Passwords do not match";
  return null;
};

const errorMessage = async (res: Response): Promise<string> => {
  try {
    const body = await res.json();
    const message = Array.isArray(body?.message) ? body.message[0] : body?.message;
    return message || `Request failed (${res.status})`;
  } catch {
    return `Request failed (${res.status})`;
  }
};
